import { useForm } from "react-hook-form";
import React, { useContext, useRef, useState } from "react";
import * as Helper from "../../form/form_inscription_helper";
import * as Pattern from "../../form/form_pattern_helper";
import CustomFieldText from "../../form/CustomFieldText";
import { Link, useNavigate } from "react-router-dom";
import Contact from "../contact";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../../context/UserContext";
import ReCAPTCHA from "react-google-recaptcha";
import GenericModal from "../../_generic_modal";

const LostPassword = () => {

  const { i18n,t } = useTranslation();

  //generic modal state
  const [showModal, setShowModal] = useState(false)
  const [modalContent, setModalContent] = useState({
    "title": "Information",
    "content": "coucou"
  })

  //submit form handle
  const { register, handleSubmit, formState: { errors } } = useForm()
  const recaptchaRef = useRef(null)
  const submitRef = useRef(null)
  const [globalError, setGlobalError] = useState("")

  const [showForm, setShowForm] = useState(true)

  const handleFormSubmit = (data) => {

    submitRef.current.setAttribute("disabled", "disabled");

    //controle recaptcha
    document.getElementById("recaptcha_error").innerHTML = " ";
    const recaptcha = recaptchaRef.current.getValue();

    //check recaptcha
    if (recaptcha.length === 0) {
      document.getElementById("recaptcha_error").innerHTML = Helper.EmptyErrorMessages.recaptcha;
      submitRef.current.removeAttribute("disabled");
      return false;
    }

    let formData = new FormData();
    formData.append('form', JSON.stringify(data));
    formData.append("recaptcha", recaptcha);
    formData.append("action", "lost_password");
    formData.append("lang", i18n.language);

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(json => {

        if (json.success === true) {

          setModalContent({
            title: t("lostpassword_information"),
            content: t("lostpassword_email_contenant_nouveau_mot_de_passe")
          })

          setShowModal(true)

        } else {

          switch (json.message) {
            case "#recaptcha":
              setGlobalError(t("lostpassword_cocher_case_robot"))
              break;

            case "#unknow_account":
              setGlobalError(t("lostpassword_compte_inconnu"))
              break;

            default:
              alert(json.message);
          }

          submitRef.current.removeAttribute("disabled");
        }

        window.grecaptcha.reset();
      });

  }

  return (
    <>
      <div className={"strate footer"} id={"connexionStrate"}>
        <div>
          <h1 dangerouslySetInnerHTML={{ __html: t("lostpassword_mot_de_passe_oublie") }} />
          <p dangerouslySetInnerHTML={{ __html: t("lostpassword_renseigner_email") }} />

          {showForm &&
            <form onSubmit={handleSubmit(handleFormSubmit)}>

              <CustomFieldText name="mail" placeholder={t("lostpassword_adresse_email")} register={register('mail', {
                required: Helper.EmptyErrorMessages.mail,
                pattern: { value: Pattern.emailPattern, message: Helper.InvalidErrorMessages.mail },
              })} error={errors.login && errors.login.message} />

              {/* recaptcha */}
              <div className="text-center" id={"recaptcha_wrapper"}>
                <ReCAPTCHA className="d-inline-block" sitekey="6LevKCQhAAAAAErcCcwZpbzQM4R_JcNDUrml4-2b" ref={recaptchaRef} />
                <div className="error text-center" id="recaptcha_error">&nbsp;</div>
              </div>

              <div className={"cta_wrapper"}>
                <div className={"error"}>{globalError}</div>
                <button className={"cta gold"} type="submit" ref={submitRef} dangerouslySetInnerHTML={{ __html: t("lostpassword_valider") }} />
              </div>
            </form>

          }

          {!showForm && <div id={"message_wrapper"} dangerouslySetInnerHTML={{ __html: t("lostpassword_email_envoye") }} />}

          <div className={"link_wrapper"}>
            {t("lostpassword_deja_compte")} <Link to={"/connexion"}>{t("lostpassword_se_connecter")}</Link>
          </div>

        </div>
      </div>

      <GenericModal showHeader={true} showFooter={true} show={showModal} handleClose={() => setShowModal(false)} >
        <p>{modalContent.content}</p>
      </GenericModal>

    </>
  )
}

export default LostPassword
